var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDescIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.95H1.95V18V20V20.05H2H12H12.05V20V18V17.95H12H2ZM6.05 6V5.95H6H2H1.95V6V8V8.05H2H6H6.05V8V6ZM2 11.95H1.95V12V14V14.05H2H9H9.05V14V12V11.95H9H2Z",
    fill: "#0096D6",
    stroke: "#0096D6",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9873 16.053L13.8666 16.053L13.952 16.1384L17.9632 20.1496L17.9985 20.185L18.0339 20.1496L22.0451 16.1384L22.1305 16.053L22.0098 16.053L19.0514 16.053L19.0514 3.97598L19.0514 3.92598L19.0014 3.92598L16.9957 3.92598L16.9457 3.92598L16.9457 3.97598L16.9457 16.053L13.9873 16.053Z",
    fill: "#0096D6",
    stroke: "#0096D6",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescIcon);
export default __webpack_public_path__ + "static/media/desc-icon.f419d19e75f7c110b23611b4ce84c2a3.svg";
export { ForwardRef as ReactComponent };